import { render, staticRenderFns } from "./Localities.vue?vue&type=template&id=143eb282&scoped=true&"
import script from "./Localities.vue?vue&type=script&lang=js&"
export * from "./Localities.vue?vue&type=script&lang=js&"
import style0 from "./Localities.vue?vue&type=style&index=0&id=143eb282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143eb282",
  null
  
)

export default component.exports